export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyDy1iF1wy204vZt7Cs_4mj6twkOAEwva0A",
    // apiKey: "AIzaSyCUvcY6xsQa_VEIePVnOuFEuy0m1Hz1910",
    authDomain: "dli3-8d99f.firebaseapp.com",
    databaseURL: "https://dli-client-default-rtdb.firebaseio.com",
    // databaseURL: "https://dli3-8d99f-default-rtdb.firebaseio.com",
    projectId: "dli3-8d99f",
    storageBucket: "dli3-8d99f.appspot.com",
    messagingSenderId: "1005567023123",
    appId: "1:1005567023123:web:3052d937f21ba884bb47e6",
    measurementId: "G-66L7LXYSQ9"
  },
  defaultAnswerCount: 4, //Answer input count,
  snackBarConfig: {
    duration: 2 * 1000
  },
  ONESIGNAL_APP_ID: "fb0ede65-0077-49df-840c-732885abeee0",
  ONESIGNAL_REST_API_KEY: "ODIxYjQzYzItNzMxZi00NWVmLTg4YWEtOTU1YzJiNDU0YTIw"
};
